import React, { useState } from "react";
import logo from "../../Assets/img/logo.svg";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";

const Header = () => {
  const [isClosed, setisClosed] = useState(true);

  const toggleMenu = () => {
    setisClosed(!isClosed);
  };
  return (
    <>
      <div id="header">
        <div id="header-inner">
          <div className="logo">
            <NavLink
              activeStyle={{
                color: "black"
              }}
              to="/"
            >
              <img src={logo} alt="IWWM" />
            </NavLink>
          </div>
          <div className="menu">
            <FontAwesomeIcon
              className="menu-icon"
              onClick={toggleMenu}
              icon={faBars}
            />
            <div className={`menu-list`}>
              <NavLink
                activeStyle={{
                  color: "black"
                }}
                to="/commissions"
              >
                COMMISSIONS
              </NavLink>
              <NavLink
                activeStyle={{
                  color: "black"
                }}
                to="/about"
              >
                ABOUT
              </NavLink>
              <NavLink
                activeStyle={{
                  color: "black"
                }}
                to="/contact"
              >
                CONTACT
              </NavLink>
            </div>
          </div>
        </div>
        <div className={`menu-mobile ${isClosed ? "" : "active"}`}>
          <FontAwesomeIcon
            className="toggler"
            onClick={toggleMenu}
            icon={faTimes}
          />
          <div className="menu-list-mobile">
            <NavLink
              onClick={toggleMenu}
              className="menu-list-mobile-link"
              activeStyle={{
                color: "black"
              }}
              to="/home"
            >
              HOME
            </NavLink>
            <br />
            <br />
            <NavLink
              onClick={toggleMenu}
              className="menu-list-mobile-link"
              activeStyle={{
                color: "black"
              }}
              to="/commissions"
            >
              COMMISSIONS
            </NavLink>
            <br />
            <br />
            <NavLink
              onClick={toggleMenu}
              className="menu-list-mobile-link"
              activeStyle={{
                color: "black"
              }}
              to="/about"
            >
              ABOUT
            </NavLink>
            <br />
            <br />
            <NavLink
              onClick={toggleMenu}
              className="menu-list-mobile-link"
              activeStyle={{
                color: "black"
              }}
              to="/contact"
            >
              CONTACT
            </NavLink>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
